module.exports = __webpack_public_path__ + "static/media/black-closed-toe-shoes.b5681d89.jpg";